/** Клиентский доступ к платному модулю «Мессенджеры». Срок и allowlist — с API. */

export const MESSENGERS_MODULE_PRICE_RUB = 490;

export function isMessengersModuleAllowed(_tenantOrSubdomain) {
  return true;
}

export function formatPriceRub(amount) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return "—";
  return `${n.toLocaleString("ru-RU")} ₽`;
}

export function isMessengersModuleActive(moduleOrTenant, plan) {
  if (plan?.messengers) return true;
  if (!moduleOrTenant) return false;
  if (moduleOrTenant.active != null) return Boolean(moduleOrTenant.active);
  const until =
    moduleOrTenant.paid_until || moduleOrTenant.messengers_paid_until;
  if (!until) return false;
  return String(until).slice(0, 10) >= new Date().toISOString().slice(0, 10);
}
